import React from 'react';
import ThongTinNguoiDungDon from './ThongTinNguoiDungDon.jsx';
import ThongTinDon from './ThongTinDon.jsx';
import ThongTinNguoiUyQuyen from './ThongTinNguoiUyQuyen.jsx';
import ThongTinCoQuanDaGiaiQuyet from './ThongTinCoQuanDaGiaiQuyet.jsx';
import { Button, Collapse } from "@blueprintjs/core";
import { HistoryDialog } from 'modules/dialog';
import moment from 'moment';
import { header } from 'constants/table';
import { ShowIf } from 'components/utils';
import DataTable from 'components/data-table';
import {
  RowItemListOrganizationPeriodical
} from 'modules/reception-periodical/datatable/detail';

class ChiTietDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state={
      data: this.props.data,
      isOpen: this.props.isOpen,
      donId: this.props.donId,
      dataGiaiQuyet: this.props.dataGiaiQuyet,
      trangThaiGiaiQuyet: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.isOpen != nextProps.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      })
    }

    if (nextProps.data.trangThaiDonInfo && nextProps.userInfo) {

      nextProps.data.trangThaiDonInfo.filter(item => {
        return item.donViId == nextProps.userInfo.donViId;
      }).map((child, i) => {
        this.setState({
          trangThaiGiaiQuyet: child.trangThaiDonText
        })
      });
    }
    this.setState({
      data: nextProps.data,
      dataGiaiQuyet: nextProps.dataGiaiQuyet
    })
  }

  showHanXuLy() {
    let hanXuLy = '';
    if (this.state.dataGiaiQuyet && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {
      hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanKTDX;
    } else {
      if (this.state.dataGiaiQuyet && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.donViThamTraXacMinhInfo &&
        this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.donViThamTraXacMinhInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

        if (this.props.loaiDon == 'DON_KHIEU_NAI') {

          if (this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanTTXM) {

            hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanTTXM;
          } else {

            hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM;
          }
        } else {

          hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM;
        }
      }

      if (this.state.data.donViXuLyGiaiQuyetInfo && this.state.data.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

        if (this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyet && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanGiaiQuyet) {

          hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanGiaiQuyet;
        } else {
          hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanGiaiQuyet ? this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanGiaiQuyet : '';
        }
      }
    }
    return hanXuLy ? moment(hanXuLy).format('DD/MM/YYYY') : '';
  }

  handleClick() {
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    return (
      <div className="content-wrap content-gqd background-detail panel-page">
        <div className={this.state.isOpen ? 'header-redirect background-detail' : 'background-detail header-redirect no-border-bottom'}>
          <div className="row-col">
            <ShowIf condition={this.state.data.ma != ''}>
              <div className="header-col pl15">
                <p className="txt-bold">Mã đơn:</p>
                {this.state.data.ma ? this.state.data.ma : ''}
              </div>
            </ShowIf>
            <div className={this.state.data.ma ? "header-col" : "header-col pl15"}>
              <p className="txt-bold">Ngày tiếp nhận:</p>
              {this.state.data.ngayTiepNhan ? moment(this.state.data.ngayTiepNhan).format('DD/MM/YYYY') : ''}
            </div>
            <div className="header-col">
              <p className="txt-bold">Cơ quan đã giải quyết:</p>
              {this.state.data.coThongTinCoQuanDaGiaiQuyet && this.state.data.coQuanDaGiaiQuyetDon ? this.state.data.coQuanDaGiaiQuyetDon.ten : this.state.data.coQuanDaGiaiQuyetDonThu}
            </div>
            <div className="header-col">
              <p className="txt-bold">Cơ quan đang giải quyết:</p>
              {this.state.data.coQuanDangQuyetInfo ? this.state.data.coQuanDangQuyetInfo.ten : ''}
            </div>
            <div className="header-col">
              <p className="txt-bold">Trạng thái giải quyết:</p>
              {this.state.trangThaiGiaiQuyet}
            </div>
            <div className="header-col">
              <p className="txt-bold">Hạn giải quyết:</p>
              {this.showHanXuLy()}
            </div>
            <div className="header-col">
              <HistoryDialog donId={this.state.donId}/>
            </div>
            <div className="header-col pr15">
              <Button onClick={this.handleClick.bind(this)} className={this.state.isOpen ? "btn-collap active" : "btn-collap"} />
            </div>
          </div>
        </div>
        {
          this.props.coQuanToChucTiepDan.length ?
            <div className="wrapper_box">
              <div className="box-items mb0-18">
                <div className="box-forward">
                  <div className="container-box">
                    <div className="group-box pt-20 pl10 pr10">
                      <div className="title">
                        <div className="rows">
                          <div className="col-12">
                            <h3>Danh sách cơ quan, các đơn vị cùng tham gia tiếp công dân</h3>
                          </div>
                        </div>
                      </div>
                      <div className="items-form">
                        <div className="rows">
                          <div className="col-12">
                            <DataTable
                              header = {header.detailReceptionPeriodical.organization}
                              dataList = {this.props.coQuanToChucTiepDan}
                              hidePagination={true}
                              tableLoading={false}>
                              <RowItemListOrganizationPeriodical/>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          :''
        }
        <div className="wrapper_box pb0 pl10 pr10 pt10">
          <Collapse isOpen={this.state.isOpen}>
            <ThongTinNguoiDungDon
              title ="Thông tin người đứng đơn/vụ việc"
              {...this.state.data}
            />
          </Collapse>
          <ShowIf condition={this.state.data.coUyQuyen}>
            <Collapse isOpen={this.state.isOpen}>
              <div className='box-items mb0 mt20'>
                <ThongTinNguoiUyQuyen
                  title="Thông tin người được ủy quyền"
                  {...this.state.data}
                />
              </div>
              <div className="pl5 pr5 pt0 mb15"><div className="line-border"></div></div>
            </Collapse>
          </ShowIf>
          <div className={this.state.isOpen ? "box-items" : "box-items no-margin"}>
              <ThongTinDon
                listTLBC={this.props.listTLBC}
                title="Thông tin đơn/Vụ việc"
                isOpen={this.state.isOpen}
                {...this.state.data}
              />
          </div>
          <ShowIf condition={this.state.data.coThongTinCoQuanDaGiaiQuyet}>
            <Collapse isOpen={this.state.isOpen}>

            <div className="pl5 pr5 pt0 mb15"><div className="line-border"></div></div>
              <div className={this.props.isOpen ? "box-items" : "box-items no-margin"}>
                <ThongTinCoQuanDaGiaiQuyet
                  title="Thông tin cơ quan đã giải quyết"
                  {...this.state.data}
                />
              </div>
            </Collapse>
          </ShowIf>
        </div>
      </div>
    );
  }
}

ChiTietDon.defaultProps = {
  dataGiaiQuyet: [],
  coQuanToChucTiepDan: [],
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
}

export default ChiTietDon;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/ChiTietDon.jsx